/**
 * URL builders for the social-share buttons in {@link ShareModal}.
 * Mirrors green hornet's `src/utils/shareUrls.ts` so we can share
 * bullfrog content the same way the rest of the app family does.
 */

export function getFacebookShareUrl(link: string): string {
    return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(link)}`
}

export function getTwitterShareUrl(description: string, hashtags: string = 'AmazonMusic'): string {
    return `https://x.com/intent/tweet?text=${encodeURIComponent(
        description
    )}&hashtags=${encodeURIComponent(hashtags)}`
}

export function getMailShareUrl(body: string): string {
    return `mailto:?body=${encodeURIComponent(body)}`
}
